import { get, isNil } from 'lodash-es';

import type { ColorRuleProps } from '../../../core/types/color-rule.js';
import { getAccessor } from '../../../core/utils/getAccessor.js';
import type { HistogramSeries } from '../../../histogram/types/histogram.js';

// The histogram color rule matching defaults to the series name.
export const HISTOGRAM_DEFAULT_VALUE_ACCESSOR = 'name';

// Accessors that must be treated as 'name' (we read .name from the HistogramSeries directly).
const FORBIDDEN_ACCESSORS = /^name$/;

/**
 * Extracts the subject value from a HistogramSeries for color rule matching,
 * replicating the histogram's strategy.getSubject behavior.
 *
 * When no valueAccessor is provided (or when it equals "name"),
 * the subject defaults to the series name.
 */
export function getSubjectForSeries(
  rule: ColorRuleProps,
  series: HistogramSeries,
): unknown {
  const { valueAccessor } = rule;
  if (!valueAccessor || FORBIDDEN_ACCESSORS.test(valueAccessor)) {
    return series.name;
  }

  const accessor = getAccessor(valueAccessor);
  if (accessor) {
    const value = get(series, accessor);
    if (!isNil(value)) {
      return value;
    }
  }
  return null;
}
